import styles from './FullPageMessage.module.css';
import { Wordmark } from './Wordmark';

export function FullPageMessage({ title, detail, action }: {
  title: string; detail?: string; action?: { label: string; onClick: () => void };
}) {
  return (
    <main className={styles.page}>
      <Wordmark />
      <h1 className={styles.title}>{title}</h1>
      {detail && <p className={styles.detail}>{detail}</p>}
      {action && <button type="button" className="btn btn-secondary" onClick={action.onClick}>{action.label}</button>}
    </main>
  );
}
